//Api

const Production = 
    {
        api: {
            base_url:  "https://gemini-cms.nl/api/v1/", 
            code: "THeLS258MVapu2mYT6PW61r2W"
        }
    }


export default Production;